import { Rule } from "antd/es/form";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { isValidPhoneNumber } from "react-phone-number-input";

export const usePhoneNumberValidators = (): Rule[] => {
  const intl = useIntl();

  return useMemo(
    () => [
      {
        required: true,
        message: intl.formatMessage({
          defaultMessage: "Please input your phone number",
        }),
      },
      {
        message: intl.formatMessage({
          defaultMessage: "Please enter valid phone number",
        }),
        validator: async (_, value: string) => {
          if (!value || isValidPhoneNumber(value)) {
            return;
          }

          throw new Error();
        },
      },
    ],
    [intl]
  );
};
